@if (isLoadingTab()) {
    <mat-progress-bar mode="indeterminate" />
}
<mat-tab-group
    mat-stretch-tabs="false"
    mat-align-tabs="start"
    [selectedIndex]="tabIndex()"
    (selectedTabChange)="tabChange($event)"
    [class.invisible-tabs]="!shouldDisplayHeader()">
    <mat-tab label="{{ 'General.Details' | translate }}">
        <ng-content />
    </mat-tab>
    @for (resource of relatedResources(); track resource.commandName) {
        <mat-tab>
            <ng-template mat-tab-label>{{ resource.displayName }}</ng-template>
            <ng-template matTabContent>
                <ng-template [cdkPortalOutlet]="currentTab" />
            </ng-template>
        </mat-tab>
    }
</mat-tab-group>
